export default {"src":"/_next/static/media/kennekFavicon.96993769.ico","height":256,"width":256,"blurWidth":0,"blurHeight":0};